
import Image from "next/image"

export default function ProjectRow({ image1, image2, image3, image4 }) {

  return (
    <div className="relative flex flex-row flex-wrap lg:flex-nowrap gap-4 w-full mt-8">
      <div className="relative w-[40%] lg:w-1/4 pb-[22%] lg:pb-[13%] h-full">
      <Image
          fill={true}
          className="object-cover border bc-foreground"
          src={ image1 } 
          alt="Project Row Image 1">
      </Image>
      </div>
      <div className="relative w-[40%] lg:w-1/4 pb-[22%] lg:pb-[13%] h-full">
      <Image
          fill={true}
          className="object-cover border bc-foreground"
          src={ image2 } 
          alt="Project Row Image 2">
      </Image>
      </div>
      <div className="relative w-[40%] lg:w-1/4 pb-[22%] lg:pb-[13%] h-full">
      <Image
          fill={true}
          className="object-cover border bc-foreground"
          src={ image3 } 
          alt="Project Row Image 3">
      </Image>
      </div>
      <div className="relative w-[40%] lg:w-1/4 pb-[22%] lg:pb-[13%] h-full">
      <Image
          fill={true}
          className="object-cover border bc-foreground"
          src={ image4 } 
          alt="Project Row Image 4">
      </Image>
      </div>
    </div>
  );
}
